import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { LayoutService } from './service/app.layout.service';
import { NavMenuService } from './nav-menu.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  styleUrls: ['./app.sidebar.component.scss'],
})
export class AppSidebarComponent implements OnInit, OnDestroy {
  /** Inline panel takes layout space (pinned / mobile) */
  panelPinned = false;
  /** Collapsed hover flyout visible */
  flyoutOpen = false;
  private subs: Subscription[] = [];

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
    private router: Router,
    private navMenu: NavMenuService
  ) {}

  ngOnInit(): void {
    this.navMenu.load();

    this.subs.push(
      this.layoutService.detailPanelOpen$.subscribe(open => {
        this.panelPinned =
          open || this.layoutService.detailPanelPinned;
        this.syncFlyout();
      }),
      this.layoutService.previewRailId$.subscribe(() => {
        this.syncFlyout();
      }),
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe((e: any) => {
          const id = this.navMenu.matchRailIdFromUrl(
            e.urlAfterRedirects || e.url
          );
          if (id) {
            this.layoutService.clearPreview();
            this.layoutService.setActiveRailId(id, true);
          }
        })
    );

    this.panelPinned =
      this.layoutService.isDetailPanelOpen() ||
      this.layoutService.detailPanelPinned;
    this.syncFlyout();

    const initialId = this.navMenu.matchRailIdFromUrl(this.router.url);
    if (initialId) {
      this.layoutService.setActiveRailId(initialId, true);
    } else if (
      !this.layoutService.getActiveRailId() &&
      this.navMenu.sections.length
    ) {
      this.layoutService.setActiveRailId(this.navMenu.sections[0].id, true);
    }
  }

  onNavEnter(): void {
    this.layoutService.keepPreviewOpen();
  }

  onNavLeave(): void {
    this.layoutService.schedulePreviewClose();
  }

  private syncFlyout(): void {
    const preview = this.layoutService.getPreviewRailId();
    const pinned =
      this.layoutService.detailPanelPinned ||
      this.layoutService.isDetailPanelOpen();
    // Flyout only when collapsed (not pinned) and hovering
    this.flyoutOpen = !pinned && !!preview && this.layoutService.isDesktop();
    this.panelPinned = pinned;
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }
}
